import { CLUSTER } from '@/shared/config';

export const getKnowledgeBaseUrl = (isFDA: boolean): string | null => {
  switch (CLUSTER) {
    case 'us': {
      if (isFDA) {
        return 'https://kb.diagnocat.eu/usa-fda-cleared-learning-hub';
      }
      return 'https://kb.diagnocat.eu/americas-discover-diagnocat-learning-hub';
    }
    case 'ca':
      return 'https://kb.diagnocat.eu/americas-discover-diagnocat-learning-hub';
    case 'eu':
    case 'oceania':
      return 'https://kb.diagnocat.eu/europe-discover-diagnocat-learning-hub';
    case 'ru':
      return 'https://diagnocat.portal.happydesk.ru/knowledge';
    default:
      return null;
  }
};
